module.exports = __webpack_public_path__ + "img/newyork.90279b10.jpg";